import { render, staticRenderFns } from "./translationCorpusDialog.vue?vue&type=template&id=4a85598f&scoped=true&"
import script from "./translationCorpusDialog.vue?vue&type=script&lang=js&"
export * from "./translationCorpusDialog.vue?vue&type=script&lang=js&"
import style0 from "./translationCorpusDialog.vue?vue&type=style&index=0&id=4a85598f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a85598f",
  null
  
)

export default component.exports